import { Box } from "@mui/material";
import { palette, Typography, Tooltip } from "@powerdiary/components-library/lib";
import styles from "./Row.module.css";
import { useLayoutEffect, useRef, useState } from "react";

export default function Row({
    subtitle,
    value,
    dataTestIdSuffix,
    wrap = false,
}: {
    subtitle: string;
    value: string;
    dataTestIdSuffix: string;
    wrap?: boolean;
}) {
    const valueRef = useRef<HTMLSpanElement | null>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useLayoutEffect(() => {
        // When wrapping, the full value is always visible, so no overflow tooltip is needed.
        if (wrap || !valueRef.current) return;
        const { scrollWidth, clientWidth } = valueRef.current;
        setIsOverflowing(scrollWidth > clientWidth);
    }, [value, wrap]);

    return (
        <Box className={styles.flexContainer}>
            <Typography color={palette.neutral["700"]} variant="paragraphSmallRegular">
                {subtitle}
            </Typography>
            <Tooltip title={isOverflowing ? value : ""} disableHoverListener={!isOverflowing}>
                <Typography
                    variant="paragraphMediumSemiBold"
                    fontWeight="600"
                    data-test-id={`text_${dataTestIdSuffix}`}
                    className={wrap ? styles.valueWrap : styles.value}
                    ref={valueRef}
                >
                    {value}
                </Typography>
            </Tooltip>
        </Box>
    );
}
